(() => {
  const root = document.documentElement;
  const storageKey = 'iine-color-mode';
  const colorSchemeQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: light)') : null;

  const hasSavedMode = () => {
    try {
      const saved = window.localStorage.getItem(storageKey);
      return saved === 'light' || saved === 'dark';
    } catch (error) {
      return false;
    }
  };

  const setMode = (requestedMode, persist = true) => {
    const mode = requestedMode === 'light' ? 'light' : 'dark';
    root.dataset.iineTheme = mode;
    root.style.colorScheme = mode;
    if (persist) {
      try {
        window.localStorage.setItem(storageKey, mode);
      } catch (error) {
        // Storage can be unavailable in privacy mode; the current page still updates.
      }
    }
    document.querySelectorAll('[data-iine-theme-value]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.iineThemeValue === mode));
    });
  };

  const closeMarketMenus = (exception) => {
    document.querySelectorAll('[data-iine-header-market] details[open]').forEach((details) => {
      if (!exception || !details.contains(exception)) details.removeAttribute('open');
    });
  };

  document.addEventListener('click', (event) => {
    const themeButton = event.target.closest('[data-iine-theme-value]');
    if (themeButton) {
      setMode(themeButton.dataset.iineThemeValue);
      return;
    }
    closeMarketMenus(event.target);
  });

  const syncCurrencyFromCountry = (countrySelect) => {
    if (!countrySelect) return;
    const selectedCountry = countrySelect.options[countrySelect.selectedIndex];
    const form = countrySelect.closest('.iine-header-market__form');
    const currencySelect = form?.querySelector('[data-iine-currency-select]');
    if (!selectedCountry || !currencySelect) return;
    const currencyCode = selectedCountry.dataset.currencyCode || '';
    if ([...currencySelect.options].some((option) => option.value === currencyCode)) {
      currencySelect.value = currencyCode;
    }
  };

  const syncCountryFromCurrency = (currencySelect) => {
    if (!currencySelect) return;
    const form = currencySelect.closest('.iine-header-market__form');
    const countrySelect = form?.querySelector('[data-iine-country-select]');
    const selectedCurrency = currencySelect.options[currencySelect.selectedIndex];
    if (!countrySelect || !selectedCurrency) return;

    const selectedCountry = countrySelect.options[countrySelect.selectedIndex];
    if (selectedCountry?.dataset.currencyCode === currencySelect.value) return;

    const representativeCountry = selectedCurrency.dataset.countryCode;
    if ([...countrySelect.options].some((option) => option.value === representativeCountry)) {
      countrySelect.value = representativeCountry;
    }
  };

  document.addEventListener('change', (event) => {
    const countrySelect = event.target.closest('[data-iine-country-select]');
    if (countrySelect) {
      syncCurrencyFromCountry(countrySelect);
      return;
    }

    const currencySelect = event.target.closest('[data-iine-currency-select]');
    if (currencySelect) syncCountryFromCurrency(currencySelect);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.iine-header-market__form');
    if (!form) return;
    syncCountryFromCurrency(form.querySelector('[data-iine-currency-select]'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMarketMenus();
      const openSearchClose = document.querySelector('.header-search-content:not(.hidden) .iine-header-search__close');
      if (openSearchClose) openSearchClose.click();
    }
  });

  const initialize = () => {
    setMode(root.dataset.iineTheme || 'dark', false);
    document.querySelectorAll('[data-iine-country-select]').forEach(syncCurrencyFromCountry);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  window.addEventListener('load', initialize, { once: true });
  colorSchemeQuery?.addEventListener?.('change', (event) => {
    if (!hasSavedMode()) setMode(event.matches ? 'light' : 'dark', false);
  });
})();
